var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose20({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0601 10L16.2666 4.79395C16.5596 4.50098 16.5596 4.02637 16.2666 3.7334C15.9736 3.44043 15.499 3.44043 15.2061 3.7334L9.99951 8.93945L4.79297 3.7334C4.5 3.44043 4.02539 3.44043 3.73242 3.7334C3.43945 4.02637 3.43945 4.50098 3.73242 4.79395L8.9389 10L3.73242 15.206C3.43945 15.499 3.43945 15.9736 3.73242 16.2666C3.8789 16.4131 4.0708 16.4863 4.26269 16.4863C4.45458 16.4863 4.64648 16.4131 4.79296 16.2666L9.9995 11.0605L15.206 16.2666C15.3525 16.4131 15.5444 16.4863 15.7363 16.4863C15.9282 16.4863 16.1201 16.4131 16.2666 16.2666C16.5596 15.9736 16.5596 15.499 16.2666 15.206L11.0601 10Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose20);
export default __webpack_public_path__ + "static/media/close-20.91dbbcaa88910e38fc4ae756e52d1c6d.svg";
export { ForwardRef as ReactComponent };